<template>
  <div v-loading.fullscreen.lock="loading" class="brand-detail">
    <div class="tabs clear">
      <a class="fl" :href="`/mall?city=${$route.query.city}`" target="_self">{{
        TLang("商城首页", "my")
      }}</a>

      <img
        class="fl"
        :src="require('@assets/images/birthday/tab_icon.png')"
        alt=""
      />

      <router-link class="fl" to="/birthday">
        {{ TLang("生日汇", "my") }}
      </router-link>

      <img
        class="fl"
        :src="require('@assets/images/birthday/tab_icon.png')"
        alt=""
      />

      <span class="fl">{{ TLang("品牌详情", "my") }}</span>
    </div>
    <div v-if="!firstLoading">
      <div v-if="emptyShow">
        <empty :content="TLang('暂无数据', 'brand')" />
      </div>
      <div v-else>
        <brand-info
          :logo="brandDetail.logo"
          :brandName="brandDetail.name"
          :brandIntroduction="brandDetail.introduction"
          :minPrice="minPrice"
        />
        <div v-if="bottomEmpty" class="detail-bottom-content">
          <img :src="require('./imgs/empty_icon.png')" alt="" />
          <div>{{ TLang("当前城市暂未开通该品牌", "brand") }}</div>
        </div>
        <div v-else class="detail-info">
          <ul class="tab-list clear" :class="{ 'show-sticky': sticky }">
            <li
              v-for="(item, index) in brandDetail.tabList"
              :key="index"
              class="fl"
              @click="handleScrollIntoView(item.id, index)"
            >
              <span :class="{ active: currentTab === index }">{{
                item.tabName
              }}</span>
            </li>
          </ul>
          <div class="detail-info-wrap" ref="totalRef">
            <div ref="codeList" v-if="tabsIdArr.includes(1)">
              <div class="title margin0">
                {{ TLang("配送到家", "brand") }}
                <!-- <span class="title-tip">需到店核销</span> -->
              </div>
              <div class="goodsList " v-if="brandCakeGoodsList.length > 0">
                <div
                  v-for="(goods, i) in brandCakeGoodsList"
                  :key="'cakeGoods_' + i"
                  class="item"
                >
                  <GoodsItem
                    :goods="goods"
                    goType="brandDetail"
                    :onAllClick="gotoDetail"
                  />
                </div>
              </div>
              <div
                v-if="cakeLoadText"
                @click="getNextPage('cakeList')"
                class="more-content"
              >
                <img
                  v-if="cakeLoadText !== TLang('查看更多', 'my')"
                  :src="require('./imgs/load_icon.png')"
                  class="pre-icon"
                />
                <span>{{ cakeLoadText }}</span>
                <img
                  v-if="cakeLoadText === TLang('查看更多', 'my')"
                  :src="require('./imgs/more_icon.png')"
                  class="after-icon"
                />
              </div>
            </div>
            <div ref="cakeList" v-if="tabsIdArr.includes(2)">
              <div class="title margin0">
                {{ TLang("电子券", "brand") }}
                <span
                  v-if="brandDetail && brandDetail.pcGoodsCouponTips"
                  class="title-tip"
                  >{{ brandDetail.pcGoodsCouponTips }}</span
                >
              </div>
              <div class="goodsList">
                <div
                  v-for="(goods, i) in brandCodeGoodsList"
                  :key="'codeGoods_' + i"
                  class="item"
                >
                  <GoodsItem
                    :goods="goods"
                    goType="brandDetail"
                    :onAllClick="gotoDetail"
                  />
                </div>
              </div>
              <div
                v-if="codeLoadText"
                @click="getNextPage('codeList')"
                class="more-content"
              >
                <img
                  v-if="codeLoadText !== TLang('查看更多', 'my')"
                  :src="require('./imgs/load_icon.png')"
                  class="pre-icon"
                />
                <span>{{ codeLoadText }}</span>
                <img
                  v-if="codeLoadText === TLang('查看更多', 'my')"
                  :src="require('./imgs/more_icon.png')"
                  class="after-icon"
                />
              </div>
            </div>
            <div
              ref="exchangeList"
              v-if="tabsIdArr.includes(3)"
              class="map-detail"
            >
              <div class="title">
                {{ TLang("随心兑", "brand") }}
                <span
                  v-if="brandDetail && brandDetail.pcExchangeTips"
                  class="title-tip"
                  >{{ brandDetail.pcExchangeTips }}</span
                >
              </div>
              <div class="map-part">
                <div class="map-part-list">
                  <div class="map-part-list-top">
                    <div class="map-part-list-top-region">
                      <span @click.stop="regionClick"
                        >{{ `${city_name} ${selectRegion.regionName}` }}
                        <img :src="require('./imgs/partsMore.png')"
                      /></span>
                      <div
                        v-if="regionShow"
                        class="map-part-list-top-region-select"
                      >
                        <div
                          v-for="(item, index) in regionList"
                          :key="index + 'region'"
                          class="map-part-list-top-region-select-item"
                          :class="{
                            'select-region':
                              selectRegion &&
                              selectRegion.regionId === item.regionId,
                          }"
                          @click="selectNewRegion(item)"
                        >
                          {{ item.regionName }}
                        </div>
                      </div>
                    </div>

                    <div class="search-part">
                      <input
                        v-model="keyWord"
                        :placeholder="TLang('请输入名称查找门店', 'brand')"
                      />
                      <div class="click-part" @click="onSearch">
                        <img :src="require('./imgs/search-icon.png')" />
                      </div>
                    </div>
                  </div>
                  <div class="map-part-list-bottom">
                    <div v-if="salesroomList && salesroomList.length > 0">
                      <ExchangeList
                        :salesrooms="salesroomList"
                        :callBack="gotoMap"
                      />
                    </div>
                    <div v-else>
                      <empty :content="TLang('暂无数据', 'brand')" />
                    </div>
                  </div>
                </div>
                <DFMap :sourceData="salesroomList" :selAoi="selRoom" />
              </div>
            </div>

            <div
              ref="brandStory"
              v-if="tabsIdArr.includes(4)"
              class="brand-story padding50"
            >
              <div class="title">
                {{ TLang("品牌故事", "brand") }}
              </div>
              <p v-html="brandDetail.story"></p>
            </div>
          </div>
        </div>
        <el-dialog
          title=""
          top="35vh"
          :visible.sync="codeVisible"
          width="420px"
          :show-close="false"
          custom-class="codeDialog"
          :before-close="handleClose"
        >
          <div class="codeInfo">
            <img
              class="close"
              :src="require('@assets/images/birthday/close_icon.png')"
              alt=""
              @click="handleClose"
            />
            <div class="dialogImg">
              <img :src="codeImg" alt="" />
            </div>
            <p class="wechat">{{ TLang("微信扫一扫", "my") }}</p>
            <p class="tip">{{ TLang("使用微信扫码立即体验随心兑", "my") }}</p>
          </div>
        </el-dialog>
      </div>
    </div>
    <FixedButton :channelName="TLang('生日汇', 'my')" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BrandInfo from "./components/brandInfo";
import Empty from "@components/empty";
import FixedButton from "@components/FixedButton";
import DFMap from "./components/map";
import {
  getNewBrandDetailData,
  getSalesroomCode,
  storeSearch,
  tabListQuery,
} from "@fetch/birthday";
import ExchangeList from "./components/exchangeList";
import GoodsItem from "../lifeIndex/GoodsItem";
import Cookies from "js-cookie";
import { fetchGoodsTags } from "@fetch";
import { setTitleInfo } from "@utils/title";
export default {
  name: "newBrandDetail",
  components: {
    BrandInfo,
    Empty,
    DFMap,
    ExchangeList,
    GoodsItem,
    FixedButton,
  },
  props: {
    addressItem: {
      default: function() {
        return {};
      },
      type: Object,
    },
  },
  watch: {
    addressItem(val = {}) {
      if (this.CookiesOne === "en-US") {
        this.city_name = val.cityNameEn;
      }
    },
  },
  data() {
    return {
      tabIndex: 0,
      brandDetail: {},
      loading: true,
      firstLoading: true,
      currentTab: 0,
      codeImg: "",
      codeVisible: false,
      resCode: 0,
      salesroomList: [],
      sourceList: [],
      regionList: [],
      brandCakeGoodsList: [],
      brandCodeGoodsList: [],
      city_id:
        (Cookies.get("address") &&
          JSON.parse(Cookies.get("address") || "{}").cityId) ||
        145,
      city_name: "",
      tabsIdArr: [],
      selectRegion: {
        regionId: "",
        regionName: this.TLang("全部区域", "brand"),
      },
      regionShow: false,
      keyWord: "",
      selectRoomItem: {},
      selRoom: null,
      tabClick: false,
      sticky: false,
      CookiesOne: Cookies.get("df_lang"),
      emptyShow: false,
      bottomEmpty: false,
      cakePage: 1,
      codePage: 1,
      cakeLoadText: "",
      codeLoadText: "",
      addressInfo: Cookies.get("address") && JSON.parse(Cookies.get("address")),
    };
  },

  computed: {
    ...mapGetters("shopCart", ["getCount"]),
    minPrice() {
      if (this.brandDetail) {
        return this.brandDetail.startPrice;
      }
      return -1;
    },
  },

  beforeRouteEnter(to, from, next) {
    // 设置body背景色
    document.body.classList.add("is-birthday");
    next();
  },

  beforeRouteLeave(to, from, next) {
    // 移除body背景色
    document.body.classList.remove("is-birthday");
    next();
  },

  created() {
    this.getBrandDetailData(this.$route.params.brandId);
    this.cartCount({ ...this.addressInfo });
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("click", this.onSeeAll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("click", this.onSeeAll);
  },
  methods: {
    ...mapActions("shopCart", ["cartCount"]),
    // 获取城市英文
    getCityData() {
      if (this.CookiesOne === "en-US") {
        this.apis.headerApi.getCityData().then((res) => {
          this.city_name = res.cityPinyin;
          // this.cid = Number(res.city);
        });
      } else {
        this.city_name =
          (Cookies.get("address") &&
            JSON.parse(Cookies.get("address") || "{}").cityName) ||
          "上海市";
      }
    },
    // 页面点击
    onSeeAll() {
      this.regionShow = false;
    },
    // 跳到详情页
    gotoDetail(goods, type) {
      // 1电子券 // 2实体
      if (goods.goodsType === 1) {
        let url = `/birthday/goods/detail/${goods.spuId}?city=${this.city_id}`
        if (goods.pcUrl){
          url = goods.pcUrl;
        }
        window.open(
          url,
          this.isFeishuOrDingding ? "_self" : "_blank"
        );
      } else {
        window.open(
          `/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`,
          this.isFeishuOrDingding ? "_self" : "_blank"
        );
      }
    },

    // 点击区域
    regionClick(env) {
      this.regionShow = !this.regionShow;
    },

    // 选择地区
    selectNewRegion(item) {
      this.selectRegion = item;
      this.regionShow = false;
      this.keyWord = "";
      const param = {
        regionId: item.regionId,
      };
      this.getNewSource(param);
    },

    //onSearch
    onSearch() {
      const param = {
        regionId: this.selectRegion.regionId,
        storeName: this.keyWord,
      };
      this.getNewSource(param);
    },

    async getNewSource(prams) {
      const newParma = {
        brandId: this.$route.params.brandId,
        channel: 3,
        isManageBrand: 1,
        ...prams,
      };
      const res = await storeSearch(newParma);
      if (Array.isArray(res) && res.length > 0) {
        this.salesroomList = res;
      } else {
        this.salesroomList = [];
      }
    },

    gotoMap(type, roomItem) {
      if (type === "map") {
        this.selRoom = roomItem;
        if (!roomItem || !roomItem.longitude || !roomItem.latitude) {
          this.$message.closeAll();
          this.$message({
            message: this.TLang("暂时无法定位该门店", "brand"),
            type: "error",
          });
        }
      } else if (type === "click") {
        this.getBrandAppletsCode(roomItem.id);
      }
    },

    // 枚举
    getRefString(id) {
      // 1 配送到家 2 电子券 3随心兑 4品牌故事
      const str = {
        1: "codeList",
        2: "cakeList",
        3: "exchangeList",
        4: "brandStory",
      };
      return str[id];
    },
    /**
     * tab切换
     * @param { Object } ref ref对象
     */
    handleScrollIntoView(id, index) {
      this.tabClick = true;
      this.currentTab = index;
      this.sticky = true;
      const currentRef = this.getRefString(id);
      const top = this.$refs[currentRef].offsetTop;
      document.documentElement.scrollTop = top - 60;
      document.body.scrollTop = top - 60;

      // this.$nextTick(()=>{
      //   this.$refs[currentRef].scrollTo({top: 60,behavior: "smooth"});
      //    this.$refs[currentRef].scrollTo = 100;
      // });

      // this.$refs[currentRef].scrollIntoView({behavior: "smooth" });

      // console.log("this.$refs",this.$refs[currentRef]);
      // this.$refs[currentRef].scrollTop = 100;
      // this.$refs[currentRef].scrollIntoView(60);
    },

    // 滚动事件
    handleScroll() {
      // f滚动时，左侧菜单高亮
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let len = this.$refs.totalRef.children.length;
      this.scrollList = [];
      if (scrollTop >= this.$refs.totalRef.children[0].offsetTop) {
        this.sticky = true;
      } else {
        this.sticky = false;
      }
      if (this.tabClick) {
        setTimeout(() => {
          this.tabClick = false;
        }, 600);
        return;
      }
      for (let i = 0; i < len; i++) {
        this.scrollList.push(this.$refs.totalRef.children[i].offsetTop - 10);
      }
      for (let j = 0; j < this.scrollList.length; j++) {
        if (
          scrollTop > this.scrollList[j] &&
          scrollTop <= this.scrollList[j + 1]
        ) {
          this.currentTab = j;
          continue;
        }
        if (scrollTop >= this.scrollList[this.scrollList.length - 1]) {
          this.currentTab = this.scrollList.length - 1;
        }
      }
    },

    /**获取入参 */
    getGoodTagsParams(categoryList) {
      const goodsList = [];
      categoryList.forEach((good) => {
        if (good.categoryId)
          goodsList.push({
            categoryId: good.categoryId,
            goodsId: good.goodsId,
          });
      });
      return goodsList;
    },

    /**
     * 获取品牌详情数据
     * @param { String }  brandId  品牌id
     * @param { String } sort  asc 低到高  desc 高到低
     */
    async getBrandDetailData(brandId) {
      try {
        getNewBrandDetailData({
          brandId,
          isManageBrand: 1,
          channel: 3,
          size: 15,
          page: 1,
          // sort,
        }).then((res) => {
          if (res) {
            this.loading = false;
            this.firstLoading = false;
            const resBody = res;
            // 整页显示空态
            if (!resBody) {
              this.emptyShow = true;
              return;
            }
            this.emptyShow = false;
            this.brandDetail = resBody || {};
            // 上面信息有 下面数据显示空态
            if (resBody.onlyHaveBrandStory === 1) {
              this.bottomEmpty = true;
              return;
            } else {
              if (!this.bottomEmpty) {
                this.bottomEmpty = false;
              }
            }
            // tab id list
            if (resBody.tabList && resBody.tabList.length > 0) {
              this.tabsIdArr = resBody.tabList.map((item) => item.id);
              // 含有随心兑
              if (this.tabsIdArr.includes(3)) {
                this.getCityData();
              }
            }
            setTitleInfo({brand: resBody.name});
            // 随心兑列表
            if (
              resBody &&
              resBody.brandSalesRooms &&
              resBody.brandSalesRooms.salesroomList &&
              resBody.brandSalesRooms.salesroomList.length > 0
            ) {
              this.salesroomList = resBody.brandSalesRooms.salesroomList;
              this.sourceList = resBody.brandSalesRooms.salesroomList;
            }
            // 品牌区域
            if (
              resBody &&
              resBody.brandSalesRooms &&
              resBody.brandSalesRooms.regionList &&
              resBody.brandSalesRooms.regionList.length > 0
            ) {
              const regions = resBody.brandSalesRooms.regionList || [];
              const resultArr = [
                { regionId: "", regionName: this.TLang("全部区域", "brand") },
              ].concat(regions);
              this.regionList = resultArr;
            }
            // 配送到家
            if (
              resBody &&
              resBody.brandCakeGoods &&
              resBody.brandCakeGoods.goodsList &&
              resBody.brandCakeGoods.goodsList.length > 0
            ) {
              resBody.brandCakeGoods.goodsList.forEach((item) => {
                // 商品图片
                item.imgGuide = item.imgUrl;
                item.goodsPrice = item.sellingPrice;
                item.tags = [];
              });

              this.getGoodsTags(resBody.brandCakeGoods.goodsList);
              this.brandCakeGoodsList = resBody.brandCakeGoods.goodsList;
              if (
                resBody.brandCakeGoods.total >
                resBody.brandCakeGoods.goodsList.length
              ) {
                this.cakeLoadText = this.TLang("查看更多", "my");
              }
            }

            // 电子券
            if (
              resBody &&
              resBody.brandCodeGoods &&
              resBody.brandCodeGoods.goodsList &&
              resBody.brandCodeGoods.goodsList.length > 0
            ) {
              resBody.brandCodeGoods.goodsList.forEach((item) => {
                // 商品图片
                item.imgGuide = item.imgUrl;
                item.goodsPrice = item.sellingPrice;
                item.tags = [];
              });
              this.brandCodeGoodsList = resBody.brandCodeGoods.goodsList;
              if (
                resBody.brandCodeGoods.total >
                resBody.brandCodeGoods.goodsList.length
              ) {
                this.codeLoadText = this.TLang("查看更多", "my");
              }
            }
          } else {
            this.emptyShow = true;
            this.loading = false;
            this.firstLoading = false;
          }
        });
      } catch (error) {
        this.emptyShow = true;
        this.loading = false;
        this.firstLoading = false;
      }
    },

    getNextPage(type) {
      // 配送到家加载下一页
      let nowText = "";
      if (type === "cakeList") {
        nowText = this.cakeLoadText;
      } else if (type === "codeList") {
        nowText = this.codeLoadText;
      }
      if (nowText != this.TLang("加载中", "brand")) {
        this.getTabList(type);
      }
    },

    // 获取tabList
    async getTabList(type) {
      let param = {
        size: 15,
        brandId: this.$route.params.brandId,
        channel: 3,
        isManageBrand: 1,
      };
      // 配送到家
      if (type === "cakeList") {
        param = {
          page: this.cakePage + 1,
          pageQueryType: 2,
          ...param,
        };
      } else if (type === "codeList") {
        // 电子券
        param = {
          page: this.codePage + 1,
          pageQueryType: 1,
          ...param,
        };
      }

      // 加载状态
      if (type === "cakeList") {
        this.cakeLoadText = this.TLang("加载中", "brand");
      } else if (type === "codeList") {
        this.codeLoadStatus = this.TLang("加载中", "brand");
      }

      try {
        tabListQuery(param).then((res) => {
          if (res) {
            const resBody = res || {};
            // 配送到家
            if (type === "cakeList") {
              this.cakePage += 1;
              if (
                resBody.brandCakeGoods &&
                resBody.brandCakeGoods.goodsList &&
                resBody.brandCakeGoods.goodsList.length > 0
              ) {
                this.getGoodsTags(resBody.brandCakeGoods.goodsList, true);
              } else {
                this.cakeLoadText = "";
              }
            } else if (type === "codeList") {
              this.codePage += 1;
              if (
                resBody.brandCodeGoods &&
                resBody.brandCodeGoods.goodsList &&
                resBody.brandCodeGoods.goodsList.length > 0
              ) {
                resBody.brandCodeGoods.goodsList.forEach((item) => {
                  // 商品图片
                  item.imgGuide = item.imgUrl;
                  item.goodsPrice = item.sellingPrice;
                  item.tags = [];
                });
                this.brandCodeGoodsList = this.brandCodeGoodsList.concat(
                  resBody.brandCodeGoods.goodsList || []
                );
                if (
                  this.brandDetail &&
                  this.brandDetail.brandCodeGoods &&
                  this.brandDetail.brandCodeGoods.total >
                    this.brandDetail.brandCodeGoods.length
                ) {
                  this.codeLoadText = this.TLang("查看更多", "my");
                } else {
                  this.codeLoadText = "";
                }
              } else {
                this.codeLoadText = "";
              } // if()
            } else {
              // 加载失败
              if (type === "cakeList") {
                this.cakeLoadText = this.TLang("加载失败", "brand");
              } else if (type === "codeList") {
                this.codeLoadText = this.TLang("加载失败", "brand");
              }
            }
          } else {
            // 加载失败
            if (type === "cakeList") {
              this.cakeLoadText = this.TLang("加载失败", "brand");
            } else if (type === "codeList") {
              this.codeLoadText = this.TLang("加载失败", "brand");
            }
          }
        });
      } catch (error) {
        // 加载失败
        if (type === "cakeList") {
          this.cakeLoadText = this.TLang("加载失败", "brand");
        } else if (type === "codeList") {
          this.codeLoadText = this.TLang("加载失败", "brand");
        }
      }
    },

    // 获取商品tag
    getGoodsTags(goodsList, isConcat) {
      const goodsListParam = this.getGoodTagsParams(goodsList);
      if (goodsListParam && goodsListParam.length > 0) {
        try {
          fetchGoodsTags({ goodsList: goodsListParam }).then((res) => {
            if (res && res.length > 0) {
              this.goodsListAddFlag(res, goodsList, isConcat);
            } else {
              // 加载失败
              this.cakeLoadText = this.TLang("加载失败", "brand");
            }
          });
        } catch (error) {
          // 加载失败
          this.cakeLoadText = this.TLang("加载失败", "brand");
        }
      }
    },

    // 商品数据拼接tag
    goodsListAddFlag(res, goodsList, isConcat) {
      goodsList.forEach((good) => {
        if (isConcat) {
          // 商品图片
          this.$set(good, "imgGuide", good.imgUrl);
          this.$set(good, "goodsPrice", good.sellingPrice);
        }
        const goodTag =
          res.find(
            (tag) =>
              tag.categoryId == good.categoryId && tag.goodsId == good.goodsId
          ) || {};
        let tags = goodTag && goodTag.tags ? goodTag.tags : [];
        //type  1特价抢购   满减     2爆炸贴       3新品
        let newTags = tags.filter((item) => item.type != 2);
        let stickerImgList = tags.filter((item) => item.type === 2);
        const promPrice = goodTag && goodTag.tags ? goodTag.promPrice : null;
        const salePrice = goodTag && goodTag.tags ? goodTag.salePrice : null;
        this.$set(good, "imgGuide", good.imgUrl);
        const bizStock =
          goodTag && goodTag.bizStock >= 0 ? goodTag.bizStock : null;
        this.$set(good, "tags", newTags);
        this.$set(good, "promPrice", promPrice);
        this.$set(good, "salePrice", salePrice);
        this.$set(good, "bizStock", bizStock);
        // 拼接折扣信息
        this.$set(good, "discount", goodTag.discount);
        this.$set(good, "discountPrice", goodTag.discountPrice);
        this.$set(good, "discountTagShow", goodTag.discountTagShow);
        this.$set(good, "mktTagShow", goodTag.mktTagShow);
        //爆炸贴数据
        this.$set(good, "stickerImgList", stickerImgList);
      });
      if (isConcat) {
        this.brandCakeGoodsList = this.brandCakeGoodsList.concat(goodsList);
        if (
          this.brandDetail.brandCakeGoods.total > this.brandCakeGoodsList.length
        ) {
          this.cakeLoadText = this.TLang("查看更多", "my");
        } else {
          this.cakeLoadText = "";
        }
      } else {
        this.brandCakeGoodsList = goodsList;
      }
      // this.indexCategoryGoodsDtos.forEach((item) => {

      // });
    },

    // 展示随心兑小程序码
    showXCX() {
      this.codeVisible = true;
    },
    handleClose() {
      this.codeVisible = false;
    },

    /**
     * 获取小程序码
     * @param { Number } brandId 品牌ID
     */
    async getBrandAppletsCode(salesroomId) {
      const resp = await getSalesroomCode({
        salesroomId,
      });
      this.codeImg = resp || "";
      if (resp) {
        this.codeVisible = true;
      } else {
        this.codeVisible = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.brand-detail {
  // padding-bottom: 1000px;
  .tabs {
    font-size: 16px;
    margin-bottom: 20px;
    a {
      width: 100px;
      border: 1px solid #ededed;
      color: #1a4a9e;
      text-align: center;
      line-height: 28px;
      border-radius: 5px;
      &:hover {
        background: #619ee0;
        color: #fff;
      }
    }
    img {
      width: 7px;
      height: 14px;
      margin: 8px 15px 0;
    }
    span {
      width: 100px;
      line-height: 30px;
      color: #fff;
      text-align: center;
      border-radius: 5px;
      background: #619ee0;
    }
  }
  .detail-info {
    background: #fff;
    border: 1px solid #ececec;
  }
  .show-sticky {
    position: fixed;
    top: 0;
  }
  .tab-list {
    line-height: 60px;
    font-size: 16px;
    color: #333333;
    border-bottom: 1px solid #ececec;
    background: #fff;
    width: 1200px;
    z-index: 999;
    height: 60px;
    box-sizing: border-box;
    padding-left: 20px;
    li {
      margin-right: 50px;
      text-align: center;
      cursor: pointer;
      height: 60px;
      box-sizing: border-box;
      & > span {
        display: inline-block;
        height: 58px;
      }
      & > span.active {
        border-bottom: 2px solid #3d96e2;
        background: #fff;
        font-weight: 500;
      }
      &:hover {
        color: #ff0000;
      }
    }
  }
  .detail-info-wrap {
    padding: 0 36px 40px;
    .changeTipWrap {
      padding: 24px 20px;
      .changeTitle {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .discount-info {
          // padding: 2px;
          // background-color: rgba(250, 140, 22, .2);
          font-size: 14px;
          // line-height: 12px;
        
          font-weight: 400;
          color: #fa8c16;
          margin-right: 9px;
        }
      }
      .changeIcon {
        color: #fff;
        background: #4a9fe6;
        width: 22px;
        line-height: 22px;
        border-radius: 2px;
        display: inline-block;
        text-align: center;
        margin-right: 10px;
      }
      .changeInfo {
        line-height: 22px;
        font-size: 14px;
      
        // color: #1A4A9E;
        color: #000000;
      }
      .changeBtn {
        width: 100px;
        height: 38px;
        line-height: 38px;
        background: #ee0020;
        border-radius: 5px;
        text-align: center;
        color: #fff;
        font-size: 14px;
      }
    }
    .flex-box {
      display: flex;
      justify-content: space-between;
    }
  }
  .brand-story {
    font-size: 14px;
    color: #333;
    h3 {
      font-size: 20px;
      color: #2351a2;
      margin-bottom: 30px;
      line-height: 1;
    }
    img {
      max-width: 100%;
    }
  }

  .codeDialog {
    .codeInfo {
      text-align: center;
      margin-top: -12px;
      position: relative;
      .close {
        position: absolute;
        width: 30px;
        height: 30px;
        top: -36px;
        right: -8px;
        cursor: pointer;
      }
      .dialogImg {
        width: 148px;
        height: 148px;
        border-radius: 2px;
        border: 1px solid #e0e6ed;
        margin: 0 auto 16px;
        img {
          display: block;
          width: 124px;
          height: 124px;
          margin: 12px auto;
        }
      }
      .wechat {
        font-size: 18px;
        color: #3d96e2;
        line-height: 20px;
      }
      .tip {
        font-size: 14px;
        color: #000;
        line-height: 20px;
      }
    }
  }

  .padding80 {
    padding-top: 80px;
  }
  .padding50 {
    padding-top: 50px;
  }
  .margin80 {
    margin-bottom: -80px;
  }
  .map-detail {
    background: white;
    width: 100%;
  }
  .title {
    height: 64px;
    border-bottom: 1px solid #e5e5e5;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    &-tip {
      margin-left: 3px;
      font-size: 14px;
      color: #cccccc;
    }
  }
  .map-part {
    width: 100%;
    height: 500px;
    position: relative;
    &-list {
      position: absolute;
      left: 20px;
      top: 20px;
      bottom: 20px;
      width: 360px;
      z-index: 2;
      &-top {
        width: 100%;
        height: 44px;
        display: flex;
        align-items: center;
        background: white;
      }
    }
  }
  .map-part-list-top-region {
    max-width: 145px;
    border-right: 1px solid #ececec;
    padding: 0 15px;
    position: relative;
    cursor: pointer;
    img {
      width: 16px;
      height: 16px;
    }
    & > span {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &-select {
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
        0px 6px 16px 0px rgba(0, 0, 0, 0.08),
        0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      background: white;
      position: absolute;
      z-index: 2;
      top: 40px;
      left: 0;
      width: 145px;
      height: 182px;
      overflow-y: auto;
      overflow-x: hidden;
      font-weight: 400;
      color: #333333;
      font-size: 14px;
      &-item {
        margin-top: 10px;
        padding: 0 15px;
      }
    }
  }
  .map-part-list-bottom {
    background: white;
    margin-top: 10px;
    height: 396px;
    overflow-y: auto;
    padding: 0 15px;
  }
  .search-part {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    height: 100%;
    .click-part {
      width: 40px;

      img {
        height: 28px;
      }
    }
    input {
      height: 100%;
      border: none;
      width: auto;
    }
    input:-ms-clear,
    select:-ms-expand {
      display: none;
    }
  }
  .goodsList {
    display: flex;
    flex-wrap: wrap;
    .item {
      padding: 15px 0;
      margin-top: 10px;
      &:hover {
        box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.05);
      }
    }
    .GoodsItem {
      width: 225px;
    }
  }
  .select-region {
    color: #3d96e2;
  }
  .margin0 {
    margin-bottom: 0px;
  }
}
.detail-bottom-content {
  background: white;
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  color: #999999;
  img {
    width: 260px;
    height: 136px;
    margin-top: 80px;
  }
}
.more-content {
  height: 60px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  cursor: pointer;
  .pre-icon {
    width: 14px;
    height: 14px;
    margin-right: 5px;
    animation: cirle-anim 1s linear infinite;
  }
  .after-icon {
    width: 11px;
    height: 10px;
    margin-left: 5px;
  }

  @keyframes cirle-anim {
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
<style>
.el-message {
  min-width: 0px !important;
}
</style>
